import { TeamCardListCombinedProps } from './types';

const usePresenter = (props: TeamCardListCombinedProps): TeamCardListCombinedProps => {
  return props;
};

export default usePresenter;
